import { Box, Skeleton } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";

interface AnalyticsMobileSkeletonProps {
  cardCount: number;
  bodyHeight: number;
}

// One shared skeleton shape for both mobile Analytics tabs — the High
// Level cards and Breakdown charts are visually the same "card with a
// header + tall body" silhouette, just with a different body height.
export default function AnalyticsMobileSkeleton({ cardCount, bodyHeight }: AnalyticsMobileSkeletonProps) {
  return (
    <Box>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            mt: spacing.Spacing.xl.$value,
            p: spacing.Spacing.xl.$value,
            borderRadius: spacing.Radius.md.$value,
            border: `1px solid ${colors.GrayLightMode[200].$value}`,
          }}
        >
          <Skeleton variant="text" width="45%" height={22} />
          <Skeleton variant="rectangular" height={bodyHeight} sx={{ mt: spacing.Spacing.lg.$value, borderRadius: spacing.Radius.xs.$value }} />
        </Box>
      ))}
    </Box>
  );
}
